// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
export type LinkedCreditNoteInvoiceFragment = { __typename?: 'InvoiceDTO', id: number };

export const LinkedCreditNoteInvoiceFragment = gql`
    fragment LinkedCreditNoteInvoice on InvoiceDTO {
  id
}
    `;
/* eslint-enable */